<template>
  <div>
    <a-modal v-model="visible" width="580px" title="添加用户" ok-text="确认" cancel-text="取消" @ok="submit" @cancel="onCancel">
      <a-form-model ref="modalForm" :model="modalForm" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
        <a-form-model-item label="用户" prop="users">
          <a-select v-model="modalForm.users" placeholder="请选择用户" mode="multiple" :filter-option="utils.filterOption">
            <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="角色" prop="role_id">
          <a-select v-model="modalForm.role_id" style="width: 100%" placeholder="用户角色">
            <a-select-option v-for="role in roleData" :key="role.role_id" :value="role.role_id">{{ role.role_name }}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { usersBindProject, roleList, usersUnboundProject } from '@/api/system/auth';
export default {
  name: 'UserModal',
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.isShow,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      projectId: this.$route.params.project_id,
      modalForm: {
        users: [],
        role_id: null,
        project_id: this.$route.params.project_id
      },
      userData: [],
      roleData: [],
      rules: {
        users: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
        role_id: [{ required: true, message: '角色不能为空', trigger: 'blur' }]
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        this.getUserList();
        this.getRoleList();
      } else {
        this.modalForm.users = [];
        this.modalForm.role_id = null;
      }
    }
  },
  methods: {
    close(type) {
      this.visible = false;
      this.$emit('close', type);
    },

    onCancel() {
      this.utils.trackClick({ name: '取消添加用户' });
      this.close('cancel');
    },

    // 获取用户列表
    getUserList() {
      usersUnboundProject({ project_id: this.projectId }).then(res => {
        this.userData = res.data.items;
      });
    },

    getRoleList() {
      roleList({ role_type: 2 }).then(response => {
        this.roleData = response.data.roles;
      });
    },

    submit() {
      this.utils.trackClick({ name: '确认添加用户' });
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          this.loading = true;
          usersBindProject(this.modalForm)
            .then(() => {
              this.$message.success('添加成功');
              this.close('submit');
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
